import { mergeClasses } from '@fluentui/react-components';

import CardBackgroundContent from 'src/components/atoms/card-background-content/CardBackgroundContent';
import CardLayoutContainer from 'src/components/molecules/card-layout-container/CardLayoutContainer';
import { BaseCardLayoutProps } from 'src/ui-models/cardLayout';
import { useCardFullImageLayoutStyles } from './CardFullImageLayout.styles';

interface CardFullImageLayoutProps extends BaseCardLayoutProps {
  imageUrl: string
}

const CardFullImageLayout: React.FC<CardFullImageLayoutProps> = ({ imageUrl, headline, body, className }) => {
  const styles = useCardFullImageLayoutStyles();
  const fullImageStyle = imageUrl && { backgroundImage: `url(${imageUrl})` };
  const backgroundStyle: React.CSSProperties = fullImageStyle || {};

  return (
    <CardLayoutContainer
      className={mergeClasses('card-full-image-layout', styles.fullImageBackground, className)}
      style={backgroundStyle}
    >
      <CardBackgroundContent headline={headline} body={body} />
    </CardLayoutContainer>
  );
};

export default CardFullImageLayout;
